import React, {useState} from 'react';
import {LegalCopy} from './LegalCopy';
import {NewsletterSignup} from './NewsletterSignup';
import {SocialButtons} from './SocialButtons';
import {useIsLargishAndUp} from '../../hooks/useMatchQuery';
import {FooterAccordion} from './FooterAccordion';
import {FooterLinks} from './FooterLinks';

import appStore from '../../images/app-store-white-bg.png';
import googleStore from '../../images/google-play-white-bg.png';

export const Footer = () => {
  const isLargeAndUp = useIsLargishAndUp();
  let isEventPage = false;
  const url = window.location.pathname + window.location.search;
  if (url.startsWith('/event') && !url.includes('/overview')) {
    isEventPage = true;
  }

  if (isEventPage) {
    return (
      <div id="footer-section" className="footer__simplified">
        <a
          href="/"
          aria-label="evite home"
          className="footer-logo footer-logo-simplified"
          data-qa-id="footer_logo"
        />
        <LegalCopy simpleFooter />
      </div>
    );
  }

  return (
    <div id="footer-section" className="footer__block">
      <div className="footer__section">
        <div className="footer__intro">
          <a href="/" aria-label="evite home" className="footer-logo" data-qa-id="footer_logo" />
          <NewsletterSignup
            isSmallButton={!window.is_mobile_site}
            subscribeButtonMessage="Sign up"
            subscribeMessage="Get America's trendiest parties delivered right to your inbox!"
          />
          {isLargeAndUp && <SocialButtons />}
        </div>

        {!isLargeAndUp ? <FooterAccordion /> : <FooterLinks />}
        {!isLargeAndUp && <SocialButtons />}

        <ul className="footer__mobile-apps">
          <li>
            <a
              href="/mobileapps/"
              title="iTunes"
              target="_blank"
              className="itunes"
              data-qa-id="footer_apple_download"
            >
              <img
                loading="lazy"
                src={appStore}
                alt="Available on the App Store"
                width="160"
                height="48"
              />
            </a>
          </li>

          <li>
            <a
              href="/mobileapps/"
              title="Android"
              target="_blank"
              className="android"
              data-qa-id="footer_google_download"
            >
              <img
                loading="lazy"
                src={googleStore}
                alt="Evite App on Google Play"
                width="160"
                height="48"
              />
            </a>
          </li>
        </ul>
      </div>

      <LegalCopy />
    </div>
  );
};
